import styled from 'styled-components';
import { BorderedRadioListField } from 'lib/iterable-hook-form/FormField';
import { Body2, colors, fontWeights, spacing } from 'ui/theme';
import { LeftDiv, Row, TextWrapper } from 'ui/radioList/RadioListStyles';
import { pxToRem } from 'utils/convert';

export const Section = styled.section`
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledBorderedRadioListField = styled(BorderedRadioListField)`
  width: 100%;

  ${Row} {
    margin-bottom: ${spacing.base};

    &:last-child {
      margin-bottom: 0;
    }
  }
  ${LeftDiv} {
    width: 100%;
  }
  ${TextWrapper} {
    width: 100%;
    max-width: ${pxToRem(430)};
  }
`;

export const Hr = styled.hr`
  height: 1px;
  background: ${colors.grey15};
  margin: 0 0 ${spacing.plusHalf};
`;

export const Content = styled.div`
  margin-top: ${spacing.half};
  width: 100%;
`;

export const FormSectionContent = styled.div`
  margin-bottom: ${spacing.base};
`;

export const DropdownWrapper = styled.div`
  margin-bottom: ${spacing.half};
`;

export const StyledHeader = styled(Body2)`
  font-weight: ${fontWeights.medium};
  margin-bottom: ${spacing.half};
  span {
    font-weight: ${fontWeights.regular};
    color: ${colors.textSecondary};
  }
`;

export const StyledDescription = styled(Body2)`
  margin-bottom: ${spacing.plusHalf};
  color: ${colors.textSecondary};
`;
